import { optionalEmailAfterTrim } from './optional-email-after-trim.js';
/** Trims, enforces max length, validates email format when present, blanks → undefined. */
export const optionalFormTrimmedEmail = (maxLength, invalidMessage) => optionalEmailAfterTrim(maxLength, undefined, invalidMessage).optional();
//# sourceMappingURL=optional-form-trimmed-email.js.map